var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1333 -1020)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#fff",
    opacity: 0.249,
    transform: "translate(1333 1020)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.056 0h-.006A13.045 13.045 0 0 0 2.485 20.7L.858 25.553l5.017-1.6A13.051 13.051 0 1 0 13.056 0zm7.6 18.432a3.683 3.683 0 0 1-2.562 1.842c-.682.145-1.573.261-4.572-.982-3.836-1.589-6.306-5.487-6.5-5.74a7.455 7.455 0 0 1-1.55-3.937A4.167 4.167 0 0 1 6.8 6.438a1.9 1.9 0 0 1 1.339-.468c.162 0 .307.008.437.015.383.016.576.039.829.644.315.759 1.082 2.632 1.173 2.824a.777.777 0 0 1 .055.706 2.256 2.256 0 0 1-.423.6c-.193.222-.375.392-.568.63-.176.207-.375.429-.153.813a11.586 11.586 0 0 0 2.118 2.632 9.6 9.6 0 0 0 3.061 1.888.825.825 0 0 0 .92-.145 15.793 15.793 0 0 0 1.02-1.351.728.728 0 0 1 .937-.284c.352.122 2.217 1.044 2.6 1.235s.636.284.729.445a3.251 3.251 0 0 1-.223 1.81z",
    transform: "translate(1341 1028) translate(0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.d5772aaacda87dcbb369cdc6b99d9c95.svg";
export { ForwardRef as ReactComponent };